import React, { useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import routes from "@/routers";
import { verifyToken } from "@/service/fetchToken";
import "./App.less";
import stores from "./stores"; // 正确引入
import {getModules} from '@/service/common';

// verifyToken(); // 验证token
function App() {
  
  useEffect(() => {
    getModules().then(res => { 
      stores.GlobalStore.setModuleData(res.items); // 正确调用
    });
  }, []);
  return <div className="App">{useRoutes(routes)}</div>;
}

export default App;
